import methods from '@/services/methods'

export default {
  list (payload) {
    return methods.sendGet(`pg/refunds`, payload, {unprivilege: 'PG Refunds', noHyptoLoader: true})
  },
  create (id, payload) {
    return methods.sendPost(`pg/orders/${id}/refund`, payload)
  },
  export (payload) {
    return methods.sendGet(`pg/refunds/export`, payload)
  },
  fetchStatus (id) {
    return methods.sendGet(`pg/refunds/${id}/status`)
  },
  bulkResendWebhook (payload) {
    return methods.sendPost(`pg/refunds/bulk_resend_webhook`, payload)
  },
  resendWebhook (id) {
    return methods.sendPost(`pg/refunds/${id}/resend_webhook`)
  },
  count (payload) {
    return methods.sendGet(`pg/refunds/count`, payload)
  }
}
